// -*-mode: rjsx -*-
// REACT
import React, { Component } from "react"
import PropTypes from "prop-types"
// eslint-disable-next-line
import clsx from "clsx"

// ROUTER
// eslint-disable-next-line
import { Link, Redirect } from "react-router-dom"

// MUI
// eslint-disable-next-line
import { makeStyles, withStyles } from "@material-ui/core/styles"
import CssBaseline from "@material-ui/core/CssBaseline"
import Typography from "@material-ui/core/Typography"
// eslint-disable-next-line
import Favorite from '@material-ui/icons/Favorite'
// eslint-disable-next-line
import FavoriteBorder from '@material-ui/icons/FavoriteBorder'
import grey from "@material-ui/core/colors/grey"
import Fab from "@material-ui/core/Fab"
import DownIcon from "@material-ui/icons/KeyboardArrowDown"
import UpIcon from "@material-ui/icons/KeyboardArrowUp"
//import LogRocket from 'logrocket'

import { 
    genUrl
} from "../../bl/A/bl"


// UTILS
import * as _ from "lodash"

// FLASH
import FlashMessage from "./../FlashMessage.js"
import FlashTopBar from "../Flash/FlashTopBar.js"
import FlashHeader from "../Flash/FlashHeader.js"
import FlashBottomPad from "../Flash/FlashBottomPad.js"
import FlashSelectList from "../Flash/FlashSelectList.js"
//import FlashItem from "../Flash/FlashItem.js"

// LOGGING SETUP
import appConfig from "./../../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<Statements>")
//LogRocket.init('sbqpcc/flashdev')


const VARIATION = "A"

const styles = theme => ({
    //
    // GLOBAL STYLES START
    //

    //
    // APPBAR
    //
    appbarRoot: {
        ...theme.css.appbarRoot,
        // desktop - if more than 600
        [theme.breakpoints.up("md")]: {
            // backgroundColor: theme.palette.primary.dark,
        },
    },

    appbarMessage: {
        ...theme.css.appbarMessage
    },

    //
    // APPHEAD
    //
    appheadRoot: {
        ...theme.css.appheadRoot,
        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            height: theme.css.appheadRoot.mobile.height, // to accomodate for 2 line issues
        },
    },

    appheadMessage: {
        ...theme.css.appheadMessage,
    },
    
    bnavbarRoot: {
        ...theme.css.bnavbarRoot,
    },
    
    contentDiv: {
        ...theme.css.contentDiv,
        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            marginTop: theme.css.contentDiv.desktop.marginTop,
            maxWidth: theme.css.contentDiv.desktop.maxWidth,
        },
    },

    separatorDiv_old: {
        ...theme.css.separatorDiv,

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            // next to just to make them protrude
            // a bit more - better than sunken in
            // on a big screen
            width: theme.css.separatorDiv.desktop.width,
            height: theme.css.separatorDiv.desktop.height,
            marginTop: theme.css.separatorDiv.desktop.marginTop, // separate sections
            marginBottom: theme.css.separatorDiv.desktop.marginBottom,
            marginLeft: theme.css.separatorDiv.desktop.marginLeft,
            borderRadius: theme.css.separatorDiv.desktop.borderRadius,
            boxShadow: theme.css.separatorDiv.desktop.boxShadow,
        },
        
    },


    separatorDiv: {
        ...theme.css.separatorDiv,

        margin: 0 ,
        marginBottom: 0,
        borderRadius: 0,

        
        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            width: theme.css.separatorDiv.desktop.width,
            height: theme.css.separatorDiv.desktop.height,
            marginTop: theme.css.separatorDiv.desktop.marginTop, // separate sections
            marginLeft: theme.css.separatorDiv.desktop.marginLeft,
            marginBottom: 10,
//            borderTopLeftRadius: 6,
//            borderTopRightRadius: 6,
        },
        
    },

    checkedCircle: {
        ...theme.css.checkedCircle
    },

    uncheckedCircle: {
        ...theme.css.uncheckedCircle
    },

    //
    // GLOBAL STYLES END
    //

    // SCROLL FAB
    fab: {
        position: "fixed",
        //        bottom: theme.spacing(12),
                bottom: theme.spacing(2),

        //        right: theme.spacing(1),
        //        left: "45%", // middle

        left: "83%", // middle

        zIndex: 500,
        
        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            left: "75%",
        },

    },
    
    fabGreen: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.custom.scrollDark,
        '&:hover': {
            backgroundColor: theme.palette.custom.scrollLight,
        },
    },
    

    continueButton: {
        margin: 20,
        padding: 8,
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.light,
        },
    },

    backButton: {
        margin: 20,
        padding: 4,
        height: 30,
        fontSize: 11,
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
        },
    },

    contactList: {
        margin: 0,
        marginTop: 0,
        // tab from the left
        padding: "0px",
        // inside the container
        width: "100%",
    },

    contactItem: {
        // gap between cards (individual items)
        margin: 0,
        // cursor: "pointer",
        borderRadius: 0, // default 4
    },

    yourReasonCard: {
//        padding: 8,
        paddingLeft: 20,
        paddingRight: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",        
        // gap between cards (individual items)
        margin: 0,
        // cursor: "pointer",
        borderRadius: 0, // default 4
        height: 74,
    },

    yourReasonTextField: {
//        margin: 8,
        width: 520,
        zIndex: 0,
        color: theme.palette.primary.contrastText,
        //        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            color: theme.palette.primary.contrastText,
            //            backgroundColor: theme.palette.primary.light,
        },

        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            width: 280,
        },

    },

    yourReasonFont:{
        fontSize: 18,
    },


    issueText: {
        display: "flex",
        marginTop: 256,
        minHeight: 64,
        justifyContent: "center", // horizontal
        alignItems: "center", // vertical
        //backgroundColor: grey[200],

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            marginTop: 268,
        },
        
    },


    //
    // new stuff
    //
    mainDiv: {
        // mobile
        marginTop: 0,
//        marginBottom: 95,
        marginLeft: "auto",
        marginRight: "auto",
        padding: 0,
        paddingTop: 90,

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            paddingTop: 100,
	    maxWidth: 600,
//            marginBottom: 120,
        },

        color: theme.palette.test.mainFG,
        background: theme.palette.test.mainBG,
    },

    subheaderText: {
        fontSize: "1.25rem",
        fontWeight: 300,
        color: grey[800],
//        marginBottom: 5,
    },


})

class Statements extends Component {

    state = {
        redirectBack: false,
        redirectContinue: false,
        isHelpVisible: false,
        yourReason: {
            txt: "",
            isChecked: false
        }
    }

    handleTextChange = name => event => {
        log.debug(` handleTextChange(): ${name} =`, event.target.value)
        if(name === "yourReason") {
            let yourReason = this.state.yourReason
            if(event.target.value.length <= 60) {
                yourReason.txt = event.target.value
                
                if(yourReason.txt.length === 0)
                    yourReason.isChecked = false
                else
                    yourReason.isChecked = true
                
                this.setState({ yourReason: yourReason})
            }
        }
    }

    handleContinueClick = () => {
        log.debug("handleContinueClick()")
        // get all the checked contacts
        let checkedItems = _.filter(this.state.gl.statements, ["isChecked", true])
        log.debug("handleContinueClick(): checkedItems = ", checkedItems)

        // let isNextHelp = checkedItems && checkedItems.length > 0  ? false : true

        let isNextHelp
        let helpText
        
        if(!checkedItems) {
            isNextHelp = true
            helpText = "Please select a statement"
        } else if (checkedItems.length === 0) {
            isNextHelp = true
            if(this.state.yourReason.isChecked) {
                helpText = "Please select additional statement"
            } else {
                helpText = "Please select a statement"
            }
        }
            
        log.debug("handleContinueClick(): isNextHelp = ", isNextHelp)
        if(isNextHelp) {
            this.setState({
                isHelpVisible: isNextHelp,
                helpText: helpText
            })
            return
        }


        // remove any yourReason if we've already advanced
        // the the rating screen
//        let removed = _.remove(this.state.gl.statements, (statement) => {
//            return statement.uuid === "yourReason"
//        })
//        log.debug(" handleContinueClick(): removed yourReason = ", removed)

        if(this.state.yourReason.isChecked) {
            let yourReasonStatement = {
                uuid: "yourReason",
                txt: this.state.yourReason.txt,
                issue: this.state.gl.currentIssue,
                isChecked: true,
                rate: 0,
            }

            log.debug("handleContinueClick(): yourReasonStatement = ", yourReasonStatement)
            // NEXT: start pushing here
            this.state.gl.statements.push(yourReasonStatement)

            let newCheckedItems = _.filter(this.state.gl.statements, ["isChecked", true])
            log.debug("handleContinueClick(): newCheckedItems after push = ", newCheckedItems)
            
        }


        
        /*
        // TODO: for now just get the first statement and copy it
        let yourReasonStatement = checkedItems[0]
        log.debug(" handleContinueClick(): this.state.yourReason = ", this.state.yourReason)
        yourReasonStatement.uuid = "yourReason"
        yourReasonStatement.txt = this.state.yourReason.txt
        log.debug(" handleContinueClick(): yourReasonStatement = ", yourReasonStatement)
        // clear statements first
        let removed = _.remove(this.state.gl.statements, (statement) => {
            return statement.uuid === "yourReason"
        })
        log.debug(" handleContinueClick(): removed = ", removed)
        //        this.state.gl.statements.push(yourReasonStatement)
        */        

        let localGL = this.state.gl
        localStorage.setItem("gl", JSON.stringify(localGL))
        log.debug("handleContinueClick(): saved localGL")

        this.setState({redirectContinue: true})
    }

    handleHelpDone = () => {
        this.setState({isHelpVisible: false})
    }

    handleBackClick_withUncheck = () => {
        log.debug("handleBackClick()")

        // do it in 2 stages on purpose, might be more interesting later
        // get checked contacts
        let checkedIssues = _.filter(this.state.gl.issues, ["isChecked", true])
        log.debug("handleBackClick(): checkedIssues = ", checkedIssues)

        _.map(checkedIssues, (issue) =>{
            // uncheck if checked
            issue.isChecked ? issue.isChecked = false : issue.isChecked = true
        })

        log.debug("handleBackClick(): unchecked checkedIssues = ", checkedIssues)

        localStorage.setItem("gl", JSON.stringify(this.state.gl))
        
        this.setState({redirectBack: true})
    }


    handleBackClick = () => {
        log.debug("handleBackClick()")
        //this.setState({redirectBack: true})
    }
    

    handleCheckboxChange = uuid => event => {
        log.debug(` handleCheckboxChange(): uuid = ${uuid}, event = ${event}`)

        // special case
        if(uuid === "yourReason") {
            let newReason = this.state.yourReason

            if(newReason.txt.length < 1 && !newReason.isChecked) {
                // we are trying to check without any text
                // don't allow to do that and just return
                // TODO: may an erro message later here
                return
            } else if(newReason.isChecked) {
                // we are unchecking, so delete the whole hing
                newReason.txt = ""
            }

            newReason.isChecked = !newReason.isChecked

            this.setState({
                yourReason: newReason
            })
            return
        }

        let item = (_.filter(this.state.gl.statements, ["uuid", uuid]))[0]
        log.debug("handleCheckboxChange(): statement found = ", item)
        if(!item.isChecked) {
            item.isChecked = true
        } else if(item.isChecked === true) {
            item.isChecked = false
        } else if(item.isChecked === false) {
            item.isChecked = false
        }

        log.debug("handleCheckboxChange(): item.isChecked = ", item.isChecked)

        this.setState({gl: this.state.gl})
    }


    handleRankListChange = (statementsArg) => {
        //log.debug(" handleRankListChange(): this.state.gl.statements = ", this.state.gl.statements)
        //log.debug(" handleRankListChange(): statementsArg = ", statementsArg)
        
        _.map(statementsArg, statement => {
            let matchingStatement = _.find(this.state.gl.statements, ["uuid", statement.uuid])
            // log.debug(" handleRankChange(): matchingStatement = ", matchingStatement)
            if(matchingStatement) matchingStatement = statement
        })

        this.setState({gl: this.state.gl}) // TODO: a bit of overkill
    }
    
    // returns true/false for FlashBottomBar
    // to determine whether to move forward or not
    handleNext = (onError) => {
        let checkedItems = _.filter(this.state.gl.statements, ["isChecked", true])
        
        if(!checkedItems || checkedItems.length === 0) {
            onError("Please select a reason")
            return false
        } else if(checkedItems.length === 1) {
                // we have only 1 reason checked
                // and that reason is "yourReason"
                let yourReason = _.find(checkedItems, ["isYourReason", true])
                if(yourReason && yourReason.isChecked) {
                    onError("Please select additional reason")
                    return false
                }
        } else {
            let yourReason = _.find(checkedItems, ["isYourReason", true])
            if(yourReason && (yourReason.txt === null || yourReason.txt === "")) {
                onError("Please fill your reason")
                return false
            }
        }

        _.map(checkedItems, (s) => {
            // s.rate = 1 we don't need that in 2 screens
            s.rate = 0 // zero out all the rates
            s.rank = 0 // zero out all the rank
            log.debug("handleNext(): s =", s)
        })
        
        log.debug("handleNext(): checkedItems =", checkedItems)
        
        let localGL = this.state.gl
        localStorage.setItem("gl", JSON.stringify(localGL))
        log.debug("handleNext(): saved localGL")

        return true
    }

    handleNextError = (text) => {
        log.debug("handleNextError(): text = ", text)
        this.setState({
            isHelpVisible: true,
            helpText: text
        })
    }

    componentWillUnmount  = () => {
        window.removeEventListener("scroll", this.handleScroll)
    }
    
    UNSAFE_componentWillMount = () => {
        log.debug("componentWillMount()")
        log.debug("componentWillMount(): VARIATION A")
        
        let localGL = JSON.parse(localStorage.getItem("gl"))

        // remove any yourReason if we've already advanced
        // the the rating screen
        // don't remove for now

        
        /*
        let removed = _.remove(localGL.statements, (statement) => {
            return statement.uuid === "yourReason"
        })
        log.debug(" componentWillMount(): removed yourReason = ", removed)

        // reset all the ranks

        
        log.debug(" componentWillMount(): localGL = ", localGL)


        if(removed.length === 1 && removed[0].issue.uuid === localGL.currentIssue.uuid) {
            // save changes
            localStorage.setItem("gl", JSON.stringify(localGL))
        }
        */
        
        
        this.setState({gl: localGL})
 
        this.setState({
            scrollerDirection: "down",
            variation: {
                  current: VARIATION,
                  A: "/statements/a",
                  B: "/statements/b",
                  F: "/statements/f",
              }
        })
        
    }

    componentDidMount = () => {
        log.trace("componentDidMount(): this.contentDivEl = ", this.contentDivEl)
        log.trace("componentDidMount(): this.state = ", this.state)
        window.addEventListener("scroll", this.handleScroll);
        this.scrollToTop()
    }

    handleScroll = (event) => {
        log.trace("<Issues>: handleScroll(): event = ", event)

        if(!this.state.scrollerDirection) {
            this.setState({scrollerDirection: "down"})
            return
        }

        const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
        const body = document.body;
        const html = document.documentElement;
        const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight,  html.scrollHeight, html.offsetHeight);
        const windowBottom = windowHeight + window.pageYOffset;

        log.trace("handleScroll(): window.pageYOffset =", window.pageYOffset)
        log.trace("handleScroll(): windowBottom =", windowBottom)
        log.trace("handleScroll(): docHeight =", docHeight)
        
        if (windowBottom >= (docHeight - 1)) {
            this.setState({scrollerDirection: "up"})
        } else if(window.pageYOffset === 0) {
            this.setState({scrollerDirection: "down"})
        }
    }

    scrollToBottom = () => {
        log.debug("<Issues>: scrollToBottom(): this.headDivEl = ", this.headDivEl)
        log.debug("<Issues>: scrollToBottom(): this.tailDivEl = ", this.tailDivEl)
        
        this.tailDivEl.scrollIntoView({
            behavior: "smooth",
            block: "start",
        })
    }


    scrollToTop = () => {
        log.debug("<Issues>: scrollToBottom(): this.headDivEl = ", this.headDivEl)
        log.debug("<Issues>: scrollToBottom(): this.tailDivEl = ", this.tailDivEl)
        
        this.headDivEl.scrollIntoView({
            behavior: "smooth",
            block: "start",
        })
    }


    render() {
        const { classes } = this.props

        // redirects first
        if (this.state.redirectBack) {
            return <Redirect push to="/issues"/>
        } else if(this.state.redirectContinue) {
            return <Redirect push to="/ratings"/>
        } else if(!this.state.gl.currentIssue) {
            return <Redirect push to="/contacts"/>
        }

        // let items = this.state.gl.contacts
        let items = this.state.gl.statements
        let currentIssue = this.state.gl.currentIssue
        
        let statementsItems = _.filter(items, ["issue.uuid", currentIssue.uuid])

//        let message = "Now tell your representative why " + this.state.gl.currentIssue.txt + " is important to you"


        //        let headerText1 = "Now tell your representative why " + this.state.gl.currentIssue.txt + " is important to you"
        let headerText1 = "Why is " + this.state.gl.currentIssue.txt + " important to you?"

        // ND Special
        if(this.state.gl.user.geo.address.zipPlus4 === "12345-0000") {
            log.debug("render(): I'm an ND case!!")
            headerText1 = "Now say why " + this.state.gl.currentIssue.txt + " is important to you"
        }

	return (
            <React.Fragment>
	      <CssBaseline/>

              <div ref={(el) => { this.headDivEl = el; }} ></div>
              
              <FlashMessage isVisible={this.state.isHelpVisible} variant="generic" text={this.state.helpText} onDone={this.handleHelpDone}/>
              
              <FlashTopBar text="Your Issue" variation={this.state.variation}/>

              <div className={classes.mainDiv}>

                
                <FlashHeader text={headerText1}/>

                {/*
                <Typography className={classes.subheaderText} variant="h6" style={{fontSize: "1.25rem", marginLeft: 25, marginTop: 20, marginBottom: -5, marginRight: 25}}>
                  Click on the circle to rank your reasons
                </Typography>
                 */}
                

                {/*
                <Typography className={classes.subheaderText} variant="h6" style={{marginLeft: 25, marginTop: 20, marginBottom: 10, marginRight: 25}}>
                  Rank your reasons by their importance to you. Click to generate ranking number. [...Swipe to delete reason. You can change order at any time]
                </Typography>
                 */}


                {/*
               <FlashSubHeader style={{marginBottom: 100}} text1={
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                    }}>
                      <div style={{marginBottom: 5}}>
                        <Typography variant="h6" style={{fontSize: "1.25rem"}}>
                          Click the circles to rank your reasons
                        </Typography>
                      </div>
                      <div style={{}}>
                        <HelpIcon style={{fontSize: 30, color: grey[500], paddingTop: 0, marginLeft: 5,}}/>
                      </div>

                    </div>
               }>
                  <Typography className={classes.subheaderText} variant="h6" style={{fontSize: 18, marginLeft: 10 }}>
                    <div style={{display: "inline", fontWeight: 400}}>Rank your reasons by their importance to you. Click to generate ranking number. Swipe to delete reason. You can change order at any time.</div>
                  </Typography>
                </FlashSubHeader>
                 */}


                <div style={{marginTop: 20, marginBottom: 10, marginRight: 25, marginLeft: 25}}>
                  <Typography className={classes.subheaderText} variant="h6" display="inline">
                    Select your reasons - as many as you want
                  </Typography>
                </div>

                <div className={classes.separatorDiv}>
                  <Typography variant="subtitle1" color="inherit" display="inline" style={{ fontSize: 22, fontWeight: 500 }}>
                    Reasons
                  </Typography>
                </div>

                {/*
                  <FlashRankList statements={statementsItems}
                                 onChange={this.handleRankListChange}/>
                 */}

                  <FlashSelectList statements={statementsItems}
                                 onChange={this.handleRankListChange}/>
                

                <div style={{marginTop: 25, marginBottom: 15, marginRight: 25, marginLeft: 25}}>
                  <Typography className={classes.subheaderText} variant="h6" display="inline">
                    Issues are gathered from the community at large
                </Typography>
                </div>

              </div>


              { this.state.scrollerDirection && this.state.scrollerDirection === "down" &&
                <Fab aria-label="scroll"
                     className={clsx(classes.fab, classes.fabGreen)}
                     onClick={this.scrollToBottom}>
                  <DownIcon style={{fontSize: 50}}/>
                </Fab>
              }

              { this.state.scrollerDirection && this.state.scrollerDirection === "up" &&
                <Fab aria-label="scroll"
                     className={clsx(classes.fab, classes.fabGreen)}
                     onClick={this.scrollToTop}>
                  <UpIcon style={{fontSize: 50}}/>
                </Fab>
              }
              
              
              <FlashBottomPad
                backButton={{
                    text: "BACK",
                    link: genUrl(this)("/issues"),                    
//                    link: "/issues",                    
//                    link: genUrl(this, "/issues"),
//                    onClick: this.handleBack
                }}
                nextButton={{
                    text: "NEXT",
                    link: genUrl(this)("/rankings"),                    
//                    link: "/rankings",
                    onClick: this.handleNext,
                    onError: this.handleNextError,
                }}
              />


              <div ref={(el) => { this.tailDivEl = el; }} ></div>

            </React.Fragment>
	)
    }
}

Statements.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles, {name: "Statements"})(Statements)

